export enum PaginationItemsEnum {
  HERO_SECTION = 'hero-section',
  HOW_SECTION = 'how-section',
  // PRICE_SECTION = 'price-section',
  OUR_SECTION = 'our-section',
  INFO_SECTION = 'info-section',
}
